import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_1 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";
import * as react from "react";
import { Prop, HTMLAttr } from "../Bfs.Web.Kundenportal/fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/MapUtil.js";

function attachWindowListener(f, node, eventType) {
    node.addEventListener(eventType, f);
    return {
        Dispose() {
            node.removeEventListener(eventType, f);
        },
    };
}

export const CollapsableElement = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_1("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Portale\\Collapsable.fs") + "#L") + int32ToString(value_1(20))) + ";") + "System.Tuple`2[Fable.React.ReactElement,System.Boolean]", value_1("CollapsableElement"), (tupledArg) => {
    const childElement = tupledArg[0];
    const expanded = tupledArg[1];
    const isExpanded = react.useState(expanded);
    const height = react.useState(0);
    const childRef = react.useRef(undefined);
    const containerRef = react.useRef(undefined);
    const containerExpandedClass = react.useState("");
    const containerExpandedTimout = react.useState(undefined);
    const computeHeight = () => {
        height[1]((isExpanded[0]) ? value_1(childRef.current).scrollHeight : 0);
    };
    react.useEffect(() => {
        isExpanded[1](expanded);
    }, [expanded]);
    react.useEffect(() => {
        if (isExpanded[0]) {
            computeHeight();
        }
    }, [isExpanded, childElement]);
    react.useEffect(() => {
        const disp = (() => attachWindowListener((_arg_2) => {
        computeHeight();
    }, window, "resize"))();
        return () => disp.Dispose();
    }, []);
    react.useEffect(() => {
        if ((containerExpandedTimout[0]) != null) {
            window.clearTimeout(value_1(containerExpandedTimout[0]));
        }
        const matchValue = isExpanded[0];
        if (matchValue) {
            const timeoutId = window.setTimeout((_arg_5) => {
                containerExpandedClass[1]("fully-expanded");
            }, 500);
            containerExpandedTimout[1](timeoutId);
        }
        else {
            containerExpandedClass[1]("");
            window.setTimeout((_arg_4) => {
                computeHeight();
            }, 10);
        }
    }, [isExpanded[0]]);
    const props_2 = [["style", {
        height: `${height[0]}px`,
    }], new HTMLAttr(65, [`collapsable ${containerExpandedClass[0]}`]), new Prop(3, [containerRef])];
    const children_2 = [react.createElement("div", {
        ref: childRef,
    }, childElement)];
    return react.createElement("div", keyValueList(props_2, 1), ...children_2);
}, undefined, undefined, "Of");

//# sourceMappingURL=Collapsable.fs.js.map
